import React from 'react'
import "./home.css"

function Home() {
  return (
    <div className='home-container'>
       <div className='overlay'>
        <h2>
            Watch Streaming Games Anywhere Anytime.
        </h2>
        <p>Every battle must be faced bravely.Be a real fighter.
        </p>
        <button className='home-button'>
         Get started 
        </button>
       </div>
    </div>
  )
}

export default Home